import { Slider, Rail, Handles, Tracks, Ticks } from 'react-compound-slider'
import { Handle, Track, Tick } from './MoveSliderComponents'
import { langPath } from '../assets/langPath'
import { useLang } from '../utils/hooks'

import { moveSliderStyle, moveRailStyle } from './StyledElements'

const MoveSlider = ({ move_speed, handle_move_slider_change }) => {
  const { lang } = useLang()
  const choosenLang = lang === 'fr' ? langPath.fr : langPath.eng

  const onSliderChange = (nb) => {
    handle_move_slider_change(nb[0] === 0 ? 1 : nb[0])
  }

  return (
    <div className="level">
      <div className="level-item">
        <h1 className="tag is-link is-light">{choosenLang.speed + ' x'}</h1>

        <Slider
          rootStyle={moveSliderStyle}
          mode={1}
          domain={[0, 50]}
          step={5}
          values={[move_speed]}
          onChange={onSliderChange}
        >
          <Rail>
            {({ getRailProps }) => (
              <div style={moveRailStyle} {...getRailProps()} />
            )}
          </Rail>
          <Handles>
            {({ handles, getHandleProps }) => (
              <div className="move-slider-handles">
                {handles.map((handle) => (
                  <Handle
                    key={handle.id}
                    handle={handle}
                    getHandleProps={getHandleProps}
                  />
                ))}
              </div>
            )}
          </Handles>
          <Tracks left={false} right={false}>
            {({ tracks, getTrackProps }) => (
              <div className="move-slider-tracks">
                {tracks.map(({ id, source, target }) => (
                  <Track
                    key={id}
                    source={source}
                    target={target}
                    getTrackProps={getTrackProps}
                  />
                ))}
              </div>
            )}
          </Tracks>
          <Ticks>
            {({ ticks }) => (
              <div className="move-slider-ticks">
                {ticks.map((tick) => (
                  <Tick key={tick.id} tick={tick} count={ticks.length} />
                ))}
              </div>
            )}
          </Ticks>
        </Slider>
      </div>
    </div>
  )
}

export default MoveSlider
